import { isApplicationCommissionClosed } from "./commissionsConstants";

/** Closed commission cases (e.g. Final Review archive) are not bulk-selectable. */
export function isCommissionRowSelectableForBulk(
  application,
  activeReport = "commission",
) {
  if (activeReport !== "commission") {
    return true;
  }

  return !isApplicationCommissionClosed(application);
}
